import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { fromRulerActions } from './ruler.action';

@Injectable()
export class RulerEffects {
  /**
   * Mirror the obstacle/roof save pattern: any add or delete of a ruler
   * triggers the design auto-save (`SaveRulers`   handled by `saveDesign$`
   * in design.effect.ts which serializes the store and pushes to S3 + API).
   */
  triggerSaveRulers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromRulerActions.AddRuler, fromRulerActions.DeleteRuler),
      mergeMap(() => [fromRulerActions.SaveRulers()])
    )
  );

  constructor(private actions$: Actions) {}
}
